import { CustomElement } from '@aurelia/runtime-html';
export const name = "user-notice";
export const template = "<template>\n    <div show.bind=\"hasActiveNotification && notifications.length>0\">\n        <div class=\"alert alert-warning alert-dismissible fade show\" role=\"alert\">\n            <strong>${'general.user-alert-header' & t}</strong><br>\n            <div class=\"${n.last ? '' : 'border-bottom'}\"  repeat.for=\"n of notifications\" innerHtml.bind=\"n.message\">\n                <hr>\n            </div>\n          </div>\n    </div>\n</template>";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
